// extracted by mini-css-extract-plugin
export default {"user-role":"user-role_user-role__WRnxS"};